import { render, staticRenderFns } from "./DuaMessageForm.vue?vue&type=template&id=be9ba376"
import script from "./DuaMessageForm.vue?vue&type=script&lang=js"
export * from "./DuaMessageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports